import { UIActionType, UIAction } from '../../actions/uiActions';

const selectedPlanReducer = (state = '', action: UIAction) => {
  if (action.type === UIActionType.SET_SELECTED_PLAN_ID) return action.id;
  return state;
};

export default selectedPlanReducer;
